// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1C_V4","info":"UpdateTermsInfo_info__2P-zy"};